import {MARKET} from '../config';

export const getCurrency = () => {
    switch (MARKET) {
        case 'en':
            return 'USD';

        case 'cz':
            return 'CZK';

        case 'pl':
            return 'PLN';

        case 'hu':
            return 'HUF';

        case 'ro':
            return 'RON';
    }

    return 'EUR';
};
